export const table = [
  {
    name: "Cornell University",
    address: "Ithaca, New York, USA",
    status: "Complete",
    action: ".",
  },
];



// WEBPACK FOOTER //
// ./src/components/pages/VerifyMembership/table.js